import {
    // createMountsGlazingGasketConfig,
    createMountsKompasFrameConfig,
    createMountsKompasHorizontalConfig,
    createMountsKompasVerticalConfig,
} from "../../base";

import { IComponentConfig } from "@/app/@types/base-component";
import { Partition } from "@/app/domain/entities/partition";
import { MountsService } from "@/app/services/mounts.service";

const createSwingDoorMountsKompasFrameConfig = (
    partition: Partition,
): IComponentConfig => {
    const perimeter = MountsService.getPertimetr(partition);
    const qty = 4;

    return createMountsKompasFrameConfig()
        .qty(qty)
        .width(perimeter)
        .area(perimeter)
        .build();
};

const createSwingDoorMountsKompasHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const lines = MountsService.getKompasHorizontalLines();
    const length = MountsService.getKompasHorizontallLinesLength(partition, lines);

    return createMountsKompasHorizontalConfig()
        .qty(lines)
        .width(width)
        .area(length)
        .build();
};

const createSwingDoorMountsKompasVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const height = MountsService.getTotalHeight(partition);
    const lines = MountsService.getKompasVerticalLines(partition);
    const length = MountsService.getKompasVerticalLinesLength(partition, lines);

    return createMountsKompasVerticalConfig()
        .qty(lines)
        .width(height)
        .area(length)
        .build();
};

// const createSwingDoorMountsKompasGlazingGasketsConfig = (
//     partition: Partition,
// ): IComponentConfig => {
//     const verticalLines = MountsService.getKompasVerticalLines(partition);
//     const horizontalLines = MountsService.getKompasHorizontalLines(partition);

//     const totalPerimetr = MountsService.getPertimetr(partition);
//     const verticalLinesLength = MountsService.getKompasVerticalLinesLength(
//         partition,
//         verticalLines,
//     );
//     const horizontalLinesLength = MountsService.getKompasHorizontallLinesLength(
//         partition,
//         horizontalLines,
//     );

//     const total = totalPerimetr + verticalLinesLength + horizontalLinesLength;

//     return createMountsGlazingGasketConfig()
//         .qty(0)
//         .width(total)
//         .area(total)
//         .build();
// };

export const KompasSwingDoorsConfigs = (partition: Partition) => [
    createSwingDoorMountsKompasFrameConfig(partition),
    createSwingDoorMountsKompasHorizontalConfig(partition),
    createSwingDoorMountsKompasVerticalConfig(partition),
];
